import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
export const LoginPage: React.FC = () => {
  const [loginType, setLoginType] = useState<'supplier' | 'internal'>('supplier');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    login(loginType);
    navigate('/role-select');
  };
  return <div className="min-h-screen bg-surface-secondary flex flex-col justify-center items-center p-4 font-sans" data-id="element-251">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="w-full max-w-md" data-id="element-252">
        <div className="text-center mb-8" data-id="element-253">
          <h1 className="text-3xl font-bold text-fpg-navy tracking-tight mb-2" data-id="element-254">
            FairPrice Group
          </h1>
          <p className="text-text-secondary font-medium" data-id="element-255">
            Unified Supplier Portal
          </p>
        </div>

        <Card className="p-8 shadow-elevation-3" data-id="element-256">
          <div className="flex p-1 bg-surface-secondary rounded-fluent-lg mb-6" data-id="element-257">
            <button className={`flex-1 py-2 text-sm font-medium rounded-fluent transition-colors ${loginType === 'supplier' ? 'bg-surface-primary text-text-primary shadow-sm' : 'text-text-secondary hover:text-text-primary'}`} onClick={() => setLoginType('supplier')} data-id="element-258">
              Supplier Login
            </button>
            <button className={`flex-1 py-2 text-sm font-medium rounded-fluent transition-colors ${loginType === 'internal' ? 'bg-surface-primary text-text-primary shadow-sm' : 'text-text-secondary hover:text-text-primary'}`} onClick={() => setLoginType('internal')} data-id="element-259">
              FPG Colleague
            </button>
          </div>

          <form onSubmit={handleLogin} className="space-y-4" data-id="element-260">
            <div data-id="element-261">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-262">
                Email Address
              </label>
              <input type="email" defaultValue={loginType === 'supplier' ? 'james@oceanic.com' : 'sarah@fairprice.com'} className="w-full px-3 py-2 border border-border-default rounded-fluent focus:outline-none focus:ring-2 focus:ring-fpg-navy focus:border-transparent transition-shadow" required data-id="element-263" />
            </div>
            <div data-id="element-264">
              <div className="flex justify-between items-center mb-1" data-id="element-265">
                <label className="block text-sm font-medium text-text-primary" data-id="element-266">
                  Password
                </label>
                <a href="#" className="text-xs text-fpg-navy hover:underline" data-id="element-267">
                  Forgot password?
                </a>
              </div>
              <input type="password" defaultValue="password123" className="w-full px-3 py-2 border border-border-default rounded-fluent focus:outline-none focus:ring-2 focus:ring-fpg-navy focus:border-transparent transition-shadow" required data-id="element-268" />
            </div>

            <div className="flex items-center mt-2" data-id="element-269">
              <input type="checkbox" id="remember" className="rounded border-border-default text-fpg-navy focus:ring-fpg-navy" data-id="element-270" />
              <label htmlFor="remember" className="ml-2 text-sm text-text-secondary" data-id="element-271">
                Remember me on this device
              </label>
            </div>

            <Button type="submit" variant="primary" className="w-full mt-6" data-id="element-272">
              Sign In
            </Button>

            <div className="relative my-6" data-id="element-273">
              <div className="absolute inset-0 flex items-center" data-id="element-274">
                <div className="w-full border-t border-border-light" data-id="element-275"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-276">
                <span className="px-2 bg-surface-primary text-text-tertiary" data-id="element-277">
                  Or continue with
                </span>
              </div>
            </div>

            <Button type="button" variant="secondary" className="w-full" data-id="element-278">
              Sign in with SSO
            </Button>
          </form>
        </Card>

        <div className="mt-8 text-center text-xs text-text-tertiary space-x-4" data-id="element-279">
          <span data-id="element-280">© 2026 FairPrice Group</span>
          <a href="#" className="hover:text-text-secondary" data-id="element-281">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-text-secondary" data-id="element-282">
            Terms of Use
          </a>
          <a href="#" className="hover:text-text-secondary" data-id="element-283">
            Help
          </a>
        </div>
      </motion.div>
    </div>;
};